module.exports = __webpack_public_path__ + "img/instructImg.7f23b3cb.png";